var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalOp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.138306 34V48.7397C0.138306 59.3769 8.76142 68 19.3986 68H34.1383H48.878C59.5152 68 68.1383 59.3769 68.1383 48.7397V34V19.2603C68.1383 8.62311 59.5152 0 48.878 0H34.1383H19.3986C8.76142 0 0.138306 8.62311 0.138306 19.2603V34Z",
    fill: "#FFDED1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4901_6254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.591 16.9701V38.3569H34.4574C33.9389 38.3569 33.4617 38.0854 33.1901 37.641L31.2234 34.4153C30.9519 33.9709 30.4746 33.6994 29.9562 33.6994H21.1266V19.8913L24.846 16.1719H44.8011C45.229 16.1719 45.591 16.5257 45.591 16.9701Z",
    fill: "#FFCCB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7182 31.116H24.1794C23.7268 31.116 23.3647 30.7457 23.3647 30.3014V22.6897C23.3647 22.2371 23.7268 21.875 24.1794 21.875H25.7182C25.2656 21.875 24.9035 22.2371 24.9035 22.6897V30.3014C24.8953 30.754 25.2574 31.116 25.7182 31.116Z",
    fill: "#F3AE83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6058 22.6898V30.3015C32.6058 30.7459 32.2355 31.1162 31.7912 31.1162H25.71C25.2575 31.1162 24.8954 30.7459 24.8954 30.3015V22.6898C24.8954 22.2372 25.2575 21.8751 25.71 21.8751H31.7912C32.2438 21.8669 32.6058 22.2372 32.6058 22.6898Z",
    fill: "#F6C9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1266 19.8913L24.8378 16.1719V19.0931C24.8378 19.5375 24.4757 19.8913 24.0396 19.8913H21.1266Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5047 55.485H18.5098C17.6869 55.485 17.0286 54.8184 17.0286 54.0038V35.1843C17.0286 34.3614 17.6869 33.7031 18.5098 33.7031H23.5047C22.6818 33.7031 22.0235 34.3614 22.0235 35.1843V54.0038C22.0235 54.8184 22.6818 55.485 23.5047 55.485Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2238 39.8419V54.0038C50.2238 54.8184 49.5655 55.485 48.7426 55.485H23.5047C22.6818 55.485 22.0235 54.8184 22.0235 54.0038V35.1843C22.0235 34.3614 22.6818 33.7031 23.5047 33.7031H29.9644C30.4828 33.7031 30.9601 33.9664 31.2316 34.419L33.1983 37.6448C33.4699 38.0809 33.9471 38.3607 34.4656 38.3607H48.7509C49.5655 38.3524 50.2238 39.019 50.2238 39.8419Z",
    fill: "#FF9B75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0034 33.6951H18.5179C17.6951 33.6951 17.0367 34.3534 17.0367 35.1763V32.2468C17.0367 31.4486 17.6704 30.7985 18.4603 30.7656L19.0034 33.6951Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2239 32.2546V39.8417C50.2239 39.0188 49.5656 38.3605 48.7427 38.3605H45.591V35.826L47.2121 30.7734H48.7427C49.5656 30.7734 50.2239 31.44 50.2239 32.2546Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3742 20.2567H39.4028V19.228C39.4028 18.8331 39.7238 18.5039 40.127 18.5039C40.5302 18.5039 40.8511 18.8248 40.8511 19.228V20.2567H41.8797C42.2747 20.2567 42.6039 20.5776 42.6039 20.9808C42.6039 21.384 42.2829 21.7049 41.8797 21.7049H40.8511V22.7335C40.8511 23.1285 40.5302 23.4577 40.127 23.4577C39.7238 23.4577 39.4028 23.1368 39.4028 22.7335V21.7049H38.3742C37.4197 21.6803 37.4197 20.2731 38.3742 20.2567Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5322 45.8538H32.1862V44.1997C32.1862 43.5579 32.7046 43.0312 33.3547 43.0312C34.0048 43.0312 34.5232 43.5497 34.5232 44.1997V45.8538H36.1772C36.8191 45.8538 37.3457 46.3722 37.3457 47.0223C37.3457 47.6723 36.8273 48.1908 36.1772 48.1908H34.5232V49.8448C34.5232 50.4866 34.0048 51.0133 33.3547 51.0133C32.7046 51.0133 32.1862 50.4948 32.1862 49.8448V48.1908H30.5322C29.0016 48.1414 29.0016 45.8867 30.5322 45.8538Z",
    fill: "#EAEFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0795 27.9055V29.5677H25.8828V27.9055C25.8828 27.1238 26.3436 26.449 27.0102 26.1445C27.5286 26.6053 28.4338 26.6053 28.9604 26.1445C29.6187 26.449 30.0795 27.1238 30.0795 27.9055Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5201 24.9557C29.4707 26.98 26.5001 26.98 26.4507 24.9557C26.5001 22.9314 29.4707 22.9314 29.5201 24.9557Z",
    fill: "#FDAC8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0291 16.1725H26.1956L26.8622 14.0742C26.9938 13.6545 27.4464 13.4159 27.8661 13.5557L36.0291 16.1725Z",
    fill: "#FDAC8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1663 21.5385C49.1213 24.7971 46.6032 32.6474 45.5911 35.8156V19.2344L49.6561 20.5345C50.0758 20.6744 50.298 21.1188 50.1663 21.5385Z",
    fill: "#FDAC8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1266 21.6602V33.699H19.0036C18.6415 31.7817 17.4236 25.2233 17.0451 23.199C16.9628 22.7793 17.2344 22.3843 17.6458 22.3102L21.1266 21.6602Z",
    fill: "#FDAC8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.819 23.8692H34.6466C34.0706 23.8692 34.0623 22.9805 34.6466 22.9805H36.819C37.4033 22.9805 37.4033 23.861 36.819 23.8692Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5875 26.5762H34.6466C34.0706 26.5762 34.0623 25.6875 34.6466 25.6875H42.5875C43.1635 25.6875 43.1717 26.568 42.5875 26.5762Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5875 29.2051H34.6466C34.0706 29.2051 34.0623 28.3164 34.6466 28.3164H42.5875C43.1635 28.3164 43.1717 29.1969 42.5875 29.2051Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5875 31.959H34.6466C34.0706 31.959 34.0623 31.0703 34.6466 31.0703H42.5875C43.1635 31.0785 43.1717 31.959 42.5875 31.959Z",
    fill: "#FB8457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5875 34.7247H34.6466C34.0706 34.7247 34.0623 33.8359 34.6466 33.8359H42.5875C43.1635 33.8442 43.1717 34.7247 42.5875 34.7247Z",
    fill: "#FB8457"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4901_6254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1318,
    height: 42.1318,
    fill: "white",
    transform: "translate(12.5603 13.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOp);
export default __webpack_public_path__ + "static/media/totalOP.9285cd46cca174757d1e4e8664eda009.svg";
export { ForwardRef as ReactComponent };